import { PrescriptionPackage as PrescriptionPackageApi } from '@dreryk/egabinet-prescription-frontend-api';

import { PrescriptionPackage, ValidatedPrescriptionPackage } from '../types';

export const isValidatedPrescriptionPackage = (
   prescriptionPackage: PrescriptionPackage | PrescriptionPackageApi
): prescriptionPackage is ValidatedPrescriptionPackage => {
   return prescriptionPackage.packageStatus === 'ACCEPTED';
};
